import { TableColumn } from '../hooks/useTableControls'
import { ViewColumn as ViewColumnIcon } from '@mui/icons-material'
import {
  Checkbox,
  FormControlLabel,
  IconButton,
  Menu,
  MenuItem,
} from '@mui/material'
import { useState } from 'react'

interface ColumnVisibilityButtonProps {
  readonly columns: TableColumn[]
  readonly onToggleColumn: (columnId: string) => void
  readonly disabled?: boolean
}

export function ColumnVisibilityButton({
  columns,
  onToggleColumn,
  disabled,
}: ColumnVisibilityButtonProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const open = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <IconButton
        onClick={handleClick}
        size="small"
        disabled={disabled}
        sx={{ color: 'text.secondary' }}
        aria-label="column visibility"
      >
        <ViewColumnIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: { minWidth: 200 },
        }}
      >
        {columns.map((column) => (
          <MenuItem key={column.id} dense>
            <FormControlLabel
              control={
                <Checkbox
                  checked={column.visible}
                  onChange={() => onToggleColumn(column.id)}
                  size="small"
                />
              }
              label={column.label}
              sx={{ width: '100%', m: 0 }}
            />
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
